module.exports = __webpack_public_path__ + "static/media/science-card-side.a97090a6.png";